/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d075fc63f2fcbc4c48f9221541c1d067>>
 * @codegenCommand yarn build tokens
 */
export default "\nhtml[data-color-mode=\"light\"][data-theme~=\"light:light\"],\nhtml[data-color-mode=\"dark\"][data-theme~=\"dark:light\"] {\n  color-scheme: dark;\n  --ds-background-disabled: #B3DF72;\n}\n";